<div class="relative">
    <form [formGroup]="formReceita" (ngSubmit)="setRevenue()">
        <split-steps #steps [isNextStepEnabled]="isNextStepEnabled">
            <split-step [passo]="0">
                <div class="mt-3 p-fluid grid">
                    <div class="field col-12">
                        <span class="p-float-label" style="width: 400px;">
                            <p-dropdown [ngClass]="{'p-disabled': issueDiffDay || isEdit == false}"
                                (onChange)="checkTypeInvoice($event)" [options]="listRevenueInvoiceSettings"
                                [autoDisplayFirst]="false" optionLabel="description" optionValue="@id" dataKey="@id"
                                inputId="regimeTributario" formControlName="invoice">
                            </p-dropdown>
                            <label
                                [ngClass]="{'required': formReceita.get('invoice')?.hasValidator(validators.required)}"
                                for="regimeTributario">
                                Tipo de receita
                            </label>
                        </span>
                        <!--<div class="text-red-500 mt-1" *ngIf="issueInvoice == false && issueEmitInvoice">
                        Verificamos que possui pendências no cadastro fiscal, para corrigir essas pendências <a (click)="linkUnit()" class="underline font-bold cursor-pointer">clique aqui</a>.
                    </div>-->
                    </div>
                    <div class="field col-12">
                        <div class="flex gap-1 align-items-center" formGroupName="revenue">
                            <p-checkbox [disabled]="issueEdit" formControlName="invoiceBlocked" [binary]="true"
                                inputId="InvoiceBlocked" />
                            <split-tooltip-text text="Bloquear emissão de nota para essa receita"
                                [tooltipText]="tooltipContent"></split-tooltip-text>
                            <ng-template #tooltipContent>
                                <p class="m-0"><strong>Quando usar está opção?</strong></p>
                                <ul class="ul-0">
                                    <li>Caso a nota já tenha sido emitida anteriormente (evitar duplicidade).</li>
                                    <li>Parcerias ou acordos contratuais que exijam emissão por outro canal (ex:
                                        terceirizadas).</li>
                                </ul>
                            </ng-template>
                            <!--<label for="InvoiceBlocked" class="ml-2">Bloquear emissão de nota para essa receita</label>
                        <split-tooltip-info tooltipText="teste"></split-tooltip-info>-->
                        </div>
                    </div>
                </div>
                <ng-container formGroupName="revenue">
                    <ng-container *ngIf="issueSettingsCachier == false">
                        <split-header-form icon="assets/receita/document.svg">
                            Dados do cliente
                        </split-header-form>
                        <div class="mt-2 p-fluid grid">
                            <div class="field col-12 md:col-4">
                                <span class="p-float-label">
                                    <input [ngClass]="{'p-disabled': issueDiffDay || isEdit == false}" readonly
                                        type="text" id="id" pInputText formControlName="id">
                                    <label
                                        [ngClass]="{'required': revenue.get('id')?.hasValidator(validators.required)}"
                                        for="id">ID Receita</label>
                                </span>
                            </div>
                            <div class="field col-12 md:col-4">
                                <span class="p-float-label p-input-icon-right">
                                    <i class="pi pi-lock z-1"></i>
                                    <p-calendar [ngClass]="{'p-disabled':true}"
                                        maskInputCalendar inputId="calendar" appendTo="body" formControlName="date"
                                        dateFormat="dd/mm/yy">
                                    </p-calendar>
                                    <label
                                        [ngClass]="{'required': revenue.get('date')?.hasValidator(validators.required)}"
                                        for="calendar">Data</label>
                                </span>
                                <small class="text-muted block mt-1" style="color: #888; font-size: 0.85rem; display: flex; align-items: center; gap: 4px;">
                                    <i class="pi pi-lock" style="font-size: 0.75rem;"></i> Preenchida automaticamente
                                </small>
                            </div>
                            <ng-container formGroupName="payer">
                                <div class="field col-12 md:col-4">
                                    <span class="p-float-label">
                                        <input [ngClass]="{'p-disabled': isEdit == false}" type="text"
                                            mask="000.000.000-00" id="inputtext" pInputText formControlName="taxId">
                                        <label
                                            [ngClass]="{'required': payer.get('taxId')?.hasValidator(validators.required)}"
                                            for="inputtext">CPF</label>
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <span class="p-float-label">
                                        <input [ngClass]="{'p-disabled': isEdit == false}" type="text" id="inputtext"
                                            pInputText formControlName="firstName">
                                        <label
                                            [ngClass]="{'required': payer.get('firstName')?.hasValidator(validators.required)}"
                                            for="inputtext">Nome</label>
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <span class="p-float-label">
                                        <input [ngClass]="{'p-disabled': isEdit == false}" type="text" id="inputtext"
                                            pInputText formControlName="lastName">
                                        <label
                                            [ngClass]="{'required': payer.get('lastName')?.hasValidator(validators.required)}"
                                            for="inputtext">Sobrenome</label>
                                    </span>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <span class="p-float-label">
                                        <input [ngClass]="{'p-disabled': isEdit == false}" type="text"
                                            mask="(00) 00000-0000||(00) 0000-0000" id="inputtext" pInputText
                                            formControlName="contactNumber">
                                        <label
                                            [ngClass]="{'required': payer.get('contactNumber')?.hasValidator(validators.required)}"
                                            for="inputtext">Telefone</label>
                                    </span>
                                </div>
                            </ng-container>
                            <div class="warning-text mb-3">
                                <ng-template #lockIcon>
                                    <i nz-icon nzType="lock" nzTheme="outline"></i>
                                </ng-template>
                                <span>
                                    O campo <strong>Data</strong> é preenchido automaticamente com a data de hoje
                                    e não pode ser editado. Isso evita inconsistências no processo de emissão de
                                    nota fiscal.
                                </span>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="validationData">
                        <div class="flex">
                            <split-header-form icon="assets/receita/service.svg">
                                Item
                            </split-header-form>
                        </div>
                        <div class="mt-2 p-fluid grid">
                            <div class="field col-12 md:col-12" *ngIf="invoiceLoose == false">
                                <div class="flex align-items-center gap-5">
                                    <div class="flex align-items-center">
                                        <p-radioButton
                                            [ngClass]="{'p-disabled': issueDiffDay || isEdit == false}"
                                            value="service" formControlName="itemCategory"
                                            inputId="ingredient2"></p-radioButton>
                                        <label for="ingredient2" class="ml-2">Serviços</label>
                                    </div>
                                    <div class="flex align-items-center">
                                        <p-radioButton
                                            [ngClass]="{'p-disabled': issueDiffDay || isEdit == false}"
                                            value="exam" formControlName="itemCategory"
                                            inputId="ingredient1"></p-radioButton>
                                        <label for="ingredient1" class="ml-2">Exames</label>
                                    </div>
                                </div>
                            </div>
                            <div class="field col-12 md:col-4"
                                *ngIf="invoiceLoose == false && revenue.get('itemCategory')?.value == 'service'">
                                <span class="p-float-label">
                                    <p-dropdown
                                        [ngClass]="{'p-disabled': issueDiffDay || isEdit == false}"
                                        appendTo="body" [options]="listProfessionals" [filter]="true"
                                        [autoDisplayFirst]="false" filterBy="name" optionLabel="name" optionValue="@id"
                                        dataKey="@id" inputId="regimeTributario" formControlName="professional"
                                        (onChange)="getSpecialtyByProfessional(true)">
                                    </p-dropdown>
                                    <label
                                        [ngClass]="{'required': revenue.get('professional')?.hasValidator(validators.required)}"
                                        for="regimeTributario">
                                        Profissional
                                    </label>
                                </span>
                            </div>
                            <div class="field col-12 md:col-4"
                                *ngIf="invoiceLoose == false &&  revenue.get('itemCategory')?.value == 'service'">
                                <span class="p-float-label">
                                    <p-dropdown
                                        [ngClass]="{'p-disabled': issueDiffDay || isEdit == false}"
                                        appendTo="body" [options]="listSpecialties" [filter]="true"
                                        [autoDisplayFirst]="false" optionLabel="name" optionValue="@id" dataKey="@id"
                                        inputId="regimeTributario" formControlName="specialty"
                                        (onChange)="getServiceBySpecialty()">
                                    </p-dropdown>
                                    <label
                                        [ngClass]="{'required': revenue.get('specialty')?.hasValidator(validators.required)}"
                                        for="regimeTributario">
                                        Especialidade
                                    </label>
                                </span>
                            </div>

                            <div class="field col-12 md:col-4"
                                *ngIf="invoiceLoose == false && revenue.get('itemCategory')?.value == 'service'">
                                <span class="p-float-label">
                                    <p-dropdown
                                        [ngClass]="{'p-disabled': issueDiffDay || isEdit == false}"
                                        appendTo="body" [options]="listService" [autoDisplayFirst]="false"
                                        optionLabel="name" optionValue="@id" dataKey="@id" inputId="regimeTributario"
                                        formControlName="service" (onChange)="verifyService()">
                                    </p-dropdown>
                                    <label
                                        [ngClass]="{'required': revenue.get('service')?.hasValidator(validators.required)}"
                                        for="regimeTributario">
                                        Serviço
                                    </label>
                                </span>
                            </div>

                            <div class="field col-12 md:col-12"
                                *ngIf="invoiceLoose == false && revenue.get('itemCategory')?.value == 'exam'">
                                <span class="p-float-label">
                                    <p-dropdown [filter]="true" [filterBy]="'name'"
                                        [ngClass]="{'p-disabled': issueDiffDay  || isEdit == false}"
                                        appendTo="body" [options]="listExams" [autoDisplayFirst]="false"
                                        optionLabel="name" optionLabel="name" optionValue="@id" dataKey="@id"
                                        inputId="regimeTributario" formControlName="exam" (onChange)="verifyService()">
                                    </p-dropdown>
                                    <label
                                        [ngClass]="{'required': revenue.get('exam')?.hasValidator(validators.required)}"
                                        for="regimeTributario">
                                        Exame
                                    </label>
                                </span>
                            </div>

                            <div class="field col-12 md:col-12">
                                <span class="p-float-label">
                                    <p-dropdown
                                        [ngClass]="{'p-disabled': issueDiffDay || issueSettingsCachier || isEdit == false}"
                                        appendTo="body" (onChange)="checkAndChangeViewToExams($event)"
                                        [options]="listTypeRevenue" [autoDisplayFirst]="false"
                                        optionLabel="nameCategory" optionValue="@id" dataKey="@id"
                                        inputId="regimeTributario" formControlName="category">
                                    </p-dropdown>
                                    <label
                                        [ngClass]="{'required': revenue.get('category')?.hasValidator(validators.required)}"
                                        for="regimeTributario">
                                        Categoria
                                    </label>
                                </span>
                            </div>
                             <div class="field col-12 md:col-12">
                                <span class="p-float-label">
                                    <input [ngClass]="{'p-disabled': isEdit == false}" type="text" id="inputtext"
                                        pInputText formControlName="description"
                                        >
                                    <label
                                        [ngClass]="{'required': revenue.get('description')?.hasValidator(validators.required)}"
                                        for="inputtext">Observação</label>
                                </span>
                                <small
                                    class="p-error"
                                    *ngIf="revenue.get('description')?.errors?.['pattern']">
                                    Caracteres inválidos ou emojis não são permitidos.
                                </small>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="validationData && validationItem">
                        <split-header-form icon="assets/receita/payment.svg">
                            Pagamento
                        </split-header-form>
                        <div class="mt-2 p-fluid grid align-items-center">
                            <div class="field col-4 md:col-4">
                                <span class="p-float-label">
                                    <input [ngClass]="{'p-disabled': issueDiffDay || isEdit == false}"
                                        [readonly] type="text" id="inputtext" pInputText prefix="R$ " mask="separator.2"
                                        thousandSeparator="." decimalMarker="," formControlName="value">
                                    <label
                                        [ngClass]="{'required': revenue.get('value')?.hasValidator(validators.required)}"
                                        for="inputtext">Valor Total</label>
                                    <small *ngIf="formReceita.errors?.['invalidPayment']">
                                        O valor total da transação não pode ser menor que os pagamentos.
                                    </small>
                                </span>
                            </div>
                            <div class="field col-4 md:col-4 col-offset-4"
                                *ngIf="revenue.get('itemCategory')?.value == 'service' && hasCommissionPermission">
                                <div class="p-inputgroup">
                                    <span class="p-float-label">
                                        <input [readonly]="!isEditingCommission"
                                            [ngClass]="{'p-disabled': !isEditingCommission || isEdit == false}"
                                            type="text" id="inputtext" prefix="R$ " mask="separator.2"
                                            thousandSeparator="." decimalMarker="," pInputText
                                            formControlName="comissionProfessional">
                                        <label
                                            [ngClass]="{'required': revenue.get('comissionProfessional')?.hasValidator(validators.required)}"
                                            for="inputtext"> Comissão do profissional</label>
                                    </span>
                                    <button [disabled]="isEdit == false" type="button" pButton pRipple
                                        icon="pi pi-pencil" *ngIf="!isEditingCommission"
                                        (click)="toggleEditCommission()" class="p-button-secondary"></button>
                                    <button [disabled]="isEdit == false" type="button" pButton pRipple icon="pi pi-undo"
                                        *ngIf="isEditingCommission" (click)="resetCommission()"
                                        class="p-button-secondary"></button>
                                </div>
                            </div>
                            <div class="field col-12 md:col-12">
                                <div class="card" *ngIf="payments.length > 0">

                                    <div formArrayName="payments">
                                        <ng-container *ngFor="let payment of payments.controls; let i = index"
                                            [formGroupName]="i">
                                            <div class="mt-2 p-fluid grid align-items-center">
                                                <div class="field m-0 col-12 md:col">
                                                    <span class="p-float-label">
                                                        <input
                                                            [ngClass]="{'p-disabled': issueDiffDay || isEdit == false}"
                                                            type="text" id="inputtext" pInputText
                                                            [readonly]="payment.get('orderId')?.value != null"
                                                            (blur)="verifyPayment(i)" prefix="R$ " mask="separator.2"
                                                            thousandSeparator="." decimalMarker=","
                                                            formControlName="value">
                                                        <label
                                                            [ngClass]="{'required': payment.get('value')?.hasValidator(validators.required)}"
                                                            for="inputtext">{{i + 1}}º Valor</label>
                                                    </span>
                                                </div>
                                                <div class="field m-0 col-12 md:col">
                                                    <span class="p-float-label">
                                                        <p-dropdown
                                                            [ngClass]="{'p-disabled': issueDiffDay || issueSettingsCachier || isEdit == false}"
                                                            [readonly]="payment.get('orderId')?.value != null"
                                                            [options]="listPaymentsMethod" [autoDisplayFirst]="false"
                                                            dataKey="@id" optionLabel="name" optionValue="@id"
                                                            inputId="paymentMethod" formControlName="paymentMethod"
                                                            (onChange)="verifyPaymentMethod(i)">
                                                        </p-dropdown>
                                                        <label
                                                            [ngClass]="{'required': payment.get('paymentMethod')?.hasValidator(validators.required)}"
                                                            for="inputtext">Forma de Pagamento</label>
                                                    </span>
                                                </div>
                                                <div class="field m-0 col-12 md:col">
                                                    <span class="p-float-label">
                                                        <p-dropdown
                                                            [ngClass]="{'p-disabled': issueDiffDay || isEdit == false}"
                                                            [readonly]="payment.get('orderId')?.value != null"
                                                            [options]="listIntallmentCreditCount" dataKey="value"
                                                            optionLabel="label" optionValue="value"
                                                            [autoDisplayFirst]="false" inputId="installmentCount"
                                                            formControlName="installmentCount">
                                                        </p-dropdown>
                                                        <label
                                                            [ngClass]="{'required': payment.get('installmentCount')?.hasValidator(validators.required)}"
                                                            for="inputtext">Parcela</label>
                                                    </span>
                                                </div>
                                                <div class="field  m-0 col-12 md:col flex-grow-0">
                                                    <ng-container [ngSwitch]="payment.get('status')?.value">
                                                        <ng-container *ngSwitchCase="null">
                                                            <ng-container
                                                                *ngTemplateOutlet="paymentMachineStatusButton, context: {status: 'secondary', payment: payment, position: i}"></ng-container>
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'paid'">
                                                            <ng-container
                                                                *ngTemplateOutlet="paymentMachineStatusButton, context: {status: payment.get('orderId')?.value == null ? 'secondary' : 'success', payment: payment, position: i}"></ng-container>
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'pending'">
                                                            <ng-container
                                                                *ngTemplateOutlet="paymentMachineStatusButton, context: {status: 'warning', payment: payment, position: i}"></ng-container>
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'failed'">
                                                            <ng-container
                                                                *ngTemplateOutlet="paymentMachineStatusButton, context: {status: 'danger', payment: payment, position: i}"></ng-container>
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'splitted'">
                                                            <ng-container
                                                                *ngTemplateOutlet="paymentMachineStatusButton, context: {status: 'success', payment: payment, position: i}"></ng-container>
                                                        </ng-container>
                                                        <ng-container *ngSwitchDefault>
                                                            <ng-container
                                                                *ngTemplateOutlet="paymentMachineStatusButton, context: {status: 'secondary', payment: payment, position: i}"></ng-container>
                                                        </ng-container>
                                                    </ng-container>
                                                    <ng-template #paymentMachineStatusButton let-status="status"
                                                        let-payment="payment" let-position="position">
                                                        <div class="badge" [ngClass]="status">
                                                            <p-button
                                                                [disabled]="invoiceLoose == true ||
                                                        payment.get('paymentMethod')?.value == null ||
                                                        payment.get('paymentMethod')?.value == '/api/payment_methods/2' ||
                                                        payment.get('paymentMethod')?.value == '/api/payment_methods/5' || payment.get('status')?.value == 'splitted' || (payment.get('orderId')?.value != null && payment.get('status')?.value == 'paid' && payment.get('paymentMethod')?.value == '/api/payment_methods/4') || issueDiffDay"
                                                                [rounded]="true" [severity]="status" [outlined]="true"
                                                                (click)="openModal(position)">
                                                                <!--(issueEdit && payment.get('orderId')?.value == null)-->
                                                                <ng-template pTemplate="icon">
                                                                    <div class="flex">
                                                                        <split-icon name="credit-card-pay"
                                                                            size="24px"></split-icon>
                                                                    </div>
                                                                </ng-template>
                                                            </p-button>
                                                        </div>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </split-step>
            <split-step [passo]="1"
                *ngIf="this.revenue.valid && this.invoice.valid && !formReceita.errors?.['invalidPayment']">
                <split-header-form icon="assets/receita/home.svg">
                    Endereço
                </split-header-form>
                <p-messages [severity]="requiresAddress ? 'warn' : 'info'" [closable]="true">
                    <ng-template pTemplate>
                        <div class="revenue-address-message">
                            <i [ngClass]="requiresAddress ? 'pi pi-exclamation-triangle' : 'pi pi-info-circle'"></i>
                            <span>{{ addressScenarioMessage }}</span>
                        </div>
                    </ng-template>
                </p-messages>
                <div class="mb-2 p-fluid grid" formGroupName="address">
                    <div class="field col-12 mb-2">
                        <a class="postal-code-help-link"
                            href="https://buscacepinter.correios.com.br/app/localidade_logradouro/index.php"
                            target="_blank"
                            rel="noopener noreferrer"
                            pTooltip="Alguns CEPs gerais com final “000” foram atualizados e agora possuem numeração específica. Clique para consultar o CEP correto no site dos Correios.">
                            CEP não encontrado?
                        </a>
                    </div>
                    <div class="field col-12 md:col-4">
                        <span class="p-float-label">
                            <input [ngClass]="{'p-disabled': isEdit == false, 'ng-invalid ng-dirty': isPostalCodeNotFound}" mask="00000-000" type="text"
                                id="inputtext" pInputText formControlName="postalCode">
                            <label
                                [ngClass]="{'required': address.get('postalCode')?.hasValidator(validators.required)}"
                                for="inputtext">CEP{{ addressLabelSuffix }}</label>
                        </span>
                        <small class="p-error" *ngIf="isPostalCodeNotFound">CEP não encontrado.</small>
                        <small class="address-helper-text" *ngIf="postalCodeHelperText">{{ postalCodeHelperText }}</small>
                    </div>
                    <div class="field col-12 md:col-8">
                        <span class="p-float-label">
                            <input [readonly]="shouldLockFullPostalCodeFields" [ngClass]="{'p-disabled': shouldLockFullPostalCodeFields}" type="text" id="inputtext" pInputText
                                formControlName="streetAddress">
                            <label
                                [ngClass]="{'required': address.get('streetAddress')?.hasValidator(validators.required)}"
                                for="inputtext">Logradouro{{ addressLabelSuffix }}</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-4">
                        <span class="p-float-label">
                            <input [readonly]="shouldBlockAddressFieldsByPostalCode" [ngClass]="{'p-disabled': shouldBlockAddressFieldsByPostalCode}"  type="number" min="0" max="9999999999"
                                id="inputtext" pInputText formControlName="number">
                            <label [ngClass]="{'required': address.get('number')?.hasValidator(validators.required)}"
                                for="inputtext">Número{{ addressLabelSuffix }}</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-4">
                        <span class="p-float-label">
                            <input [readonly]="shouldLockFullPostalCodeFields" [ngClass]="{'p-disabled': shouldLockFullPostalCodeFields}" type="text" id="inputtext" pInputText
                                formControlName="district">
                            <label [ngClass]="{'required': address.get('district')?.hasValidator(validators.required)}"
                                for="inputtext">Bairro{{ addressLabelSuffix }}</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-4">
                        <span class="p-float-label">
                            <input [readonly]="shouldBlockAddressFieldsByPostalCode" [ngClass]="{'p-disabled': shouldBlockAddressFieldsByPostalCode}"  type="text" id="inputtext" pInputText
                                formControlName="address2">
                            <label [ngClass]="{'required': address.get('address2')?.hasValidator(validators.required)}"
                                for="inputtext">Complemento{{ addressLabelSuffix }}</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-4">
                        <span class="p-float-label">
                            <input [readonly]="shouldLockCityStateFields" [ngClass]="{'p-disabled': shouldLockCityStateFields}" type="text" id="inputtext" pInputText
                                formControlName="state">
                            <!--<p-dropdown [ngClass]="{'p-disabled': isEdit == false}" [options]="listStates"
                                [autoDisplayFirst]="false" optionLabel="name" optionLabel="name" optionValue="uf"
                                dataKey="uf" formControlName="state" appendTo="body" (onChange)="getCitiesByState()">
                            </p-dropdown>-->
                            <label [ngClass]="{'required': address.get('state')?.hasValidator(validators.required)}"
                                for="inputtext">Estado{{ addressLabelSuffix }}</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-4">
                        <span class="p-float-label">
                            <input [readonly]="shouldLockCityStateFields" [ngClass]="{'p-disabled': shouldLockCityStateFields}" type="text" id="inputtext" pInputText
                                formControlName="city">
                            <!--AngleDownIcon [ngClass]="{'p-disabled': isEdit == false}" [options]="listCities"
                                [autoDisplayFirst]="false" optionLabel="nome" optionValue="id" dataKey="id"
                                formControlName="ibge" appendTo="body">
                            </p-dropdown>-->
                            <label [ngClass]="{'required': address.get('city')?.hasValidator(validators.required)}"
                                for="inputtext">Cidade{{ addressLabelSuffix }}</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-4">
                        <span class="p-float-label">
                            <input [readonly]="shouldBlockAddressFieldsByPostalCode" [ngClass]="{'p-disabled': shouldBlockAddressFieldsByPostalCode}" type="email" id="inputtext" pInputText
                                formControlName="email">
                            <label [ngClass]="{'required': address.get('email')?.hasValidator(validators.required)}"
                                for="inputtext">Email{{ addressLabelSuffix }}</label>
                        </span>
                    </div>
                </div>
            </split-step>

            <ng-template #customNextButton *ngIf="steps.activeIndex == 1 || invoiceId == 4 || invoiceId == 5">
                <div class="flex align-items-center justify-content-end">
                    <p-button [disabled]="(requiresAddressCompletion && address.invalid && steps.activeIndex == 1) || isEdit == false  || loading" type="submit"
                        label="Finalizar" icon="pi pi-check" iconPos="right"></p-button>
                </div>
            </ng-template>
        </split-steps>
    </form>

    <div class="loading" *ngIf="loading">
        <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>

</div>


<split-sheet-modal name="sheetModalMachine">
    <div class="confirm flex h-full flex-column justify-content-center align-items-center">
        <p class="title mb-4">Selecionar maquininha:</p>
        <span class="subtitle mb-6">Selecione em qual maquininha você deseja faturar</span>
        <div class="content">
            <p-dropdown placeholder="Maquininha" [(ngModel)]="selectMachine" (onChange)="verifyMachine($event)"
                [style]="{'minWidth':'400px'}" [options]="listMachine" [autoDisplayFirst]="false"
                optionLabel="description" optionValue="serialNumber" inputId="regimeTributario">
            </p-dropdown>
        </div>
        <div class="footer flex justify-content-center align-items-end">
            <p-button (click)="closeModal()" label="Cancelar" [outlined]="true" severity="secondary"></p-button>
        </div>
    </div>
</split-sheet-modal>

<split-sheet-modal name="sheetModalPixPayment">
    <div *ngIf="this.selectedPayment" class="confirm flex h-full flex-column align-items-center">
        <img src="assets/logo.svg" />
        <p class="title mb-4">Pagamento de {{ this.selectedPayment.value | currency:'BRL'}} pelo Pix</p>
        <img [src]="this.selectedPayment.qrCodeUrlPix" />
        <div class="flex gap-2 flex-column justify-content-center align-items-center">
            <div class="p-inputgroup">
                <input #linkPaymentPix readonly type="text" pInputText [ngModel]="this.selectedPayment.qrCodePix" />
                <button (click)="copyLinkPixPayment(linkPaymentPix.value)" type="button" pButton
                    class="p-button-secondary">Copiar</button>
            </div>
            <div class="p-inputgroup">
                <input [formControl]="phoneWhatsApp" mask="(00) 00000-0000" type="text" pInputText
                    placeholder="Digite o número" />
                <button (click)="sendWhatsappMessage()" type="button" pButton>Compartilhar</button>
            </div>
        </div>
        <div class="footer flex gap-2 justify-content-center align-items-end">
            <p-button (click)="canceledOrder()" label="Cancelar Transação" [outlined]="true"
                severity="secondary"></p-button>
            <p-button (click)="closeModalPixPayment()" label="Concluir Transação" severity="secondary"></p-button>
        </div>
    </div>

    <div class="loading" *ngIf="loadingCancel == true">
        <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
</split-sheet-modal>

<split-sheet-modal [loading]="loadingSheetModalConfirmInvoices" name="sheetModalConfirmInvoices">
    <div class="confirm flex h-full flex-column justify-content-center align-items-center">
        <img src="assets/receita/alert-octagon.svg" />
        <p class="title mb-4">Tem certeza que deseja faturar {{ this.selectedPayment &&
            this.selectedPayment.paymentMethod != '/api/payment_methods/4' ? 'pela maquininha' : 'pelo Pix' }}?</p>
        <div class="content  w-full">
            <split-table [dados]="[revenue.value]" theme="tertiary">
                <ng-template #header>Nome</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    {{item.payer.firstName}} {{item.payer.lastName}}
                </ng-template>
                <ng-template #header>Profissional</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    {{this.professional?.name}}
                </ng-template>
                <ng-template #header>Especialidade</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    {{this.specialty?.name}}
                </ng-template>
                <ng-template #header>Categoria</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    {{this.category?.nameCategory}}
                </ng-template>
                <ng-template #header>Valor</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    {{item.payments[positionPayment]?.value | currency:'BRL'}}
                </ng-template>
                <ng-template #header>Pagamento</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    {{this.paymentFees?.totalAmount | currency:'BRL'}}<br />
                    <i *ngIf="this.paymentFees?.installments">{{this.paymentFees?.installments}}x de
                        {{this.paymentFees?.installmentAmount | currency:'BRL'}}</i>
                </ng-template>
                <ng-template #header>Forma pgto</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    {{convertPaymentMethod(item.payments[positionPayment]?.paymentMethod)}}
                </ng-template>
            </split-table>
            <sub *ngIf="this.selectedPayment && this.selectedPayment.paymentMethod != '/api/payment_methods/4'"
                class="ml-5 w-full text-secondary" [style.color]="'#086975'">
                * As Taxas podem variar de acordo com as condições de parcelamento,
                <a routerLink="/financeiro/taxas" target="_blank">
                    Clique Aqui
                </a>
                para ver a tabela de Taxas.
            </sub>
        </div>
    </div>
    <div class="footer flex justify-content-center align-items-end">
        <button class="btn-split btn-split-line-default mr-3" (click)="closeModal()">Cancelar</button>
        <button class="btn-split btn-split-default" (click)="sendMachineOrder()">Faturar</button>
    </div>

    <div class="loading" *ngIf="loadingInvoice">
        <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
</split-sheet-modal>

<split-sheet-modal name="sheetModalUnLinkMachine">
    <div class="confirm relative flex h-full flex-column justify-content-center align-items-center">
        <ng-container *ngIf="loadingCancel == false">
            <img src="assets/receita/alert-octagon.svg" />
            <p class="title">Deseja desvincular faturamento
                ou estornar valor maquininha?</p>
            <span class="subtitle">
                <ul>
                    <li>Desvinculando faturamento, o mesmo não será incluído nessa receita</li>
                    <li>Estornando faturamento maquinha, irá ser cancelado valor recebido pelo cliente</li>
                </ul>
            </span>
            <div class="footer flex justify-content-center align-items-end">
                <p-button (click)="canceledOrder()" label="estornar faturamento" severity="secondary"></p-button>
                <!--<p-button *ngIf="selectedPayment?.status == 'paid'" (click)="unlinkOrder()" class="ml-3" label="desvincular faturamento" severity="secondary"></p-button>-->
            </div>
        </ng-container>
        <div class="loading" *ngIf="loadingCancel == true">
            <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
        </div>
    </div>
</split-sheet-modal>

<split-sheet-modal name="sheetModalCancelPaymentMachine">
    <div class="confirm relative flex h-full flex-column justify-content-center align-items-center">
        <ng-container *ngIf="loadingCancel == false">
            <img src="assets/receita/alert-octagon.svg" />
            <p class="title">Deseja realmente
                cancelar a transação?</p>
            <span class="subtitle">
                <ul>
                    <li>Cancelar faturamento, irá ser cancelado a transação</li>
                </ul>
            </span>
            <div class="footer flex justify-content-center align-items-end">
                <p-button (click)="canceledOrder()" label="Cancelar" severity="secondary"></p-button>
            </div>
        </ng-container>
        <div class="loading" *ngIf="loadingCancel == true">
            <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
        </div>
    </div>
</split-sheet-modal>

<p-confirmDialog [visible]="dialogInvoiceBlocked" styleClass="pDialog" [closable]="false" [blockScroll]="false">
    <ng-template pTemplate="message">
        <div class="content">
            <img src="assets/lista-unidade/modal-inativar/inativar-unidade.svg" alt="imagem deletar unidade" />
            <span class="title">
                <p>Confirmar bloqueio de emissão de nota</p>
            </span>
            <span class="message">
                <p>Ao continuar, o sistema bloqueará a emissão de nota fiscal para este atendimento.</p>
                <p class="mt-5"><strong>Quando usar esta opção?</strong></p>
                <ul class="ul-0">
                    <li>Caso a nota já tenha sido emitida anteriormente (evitar duplicidade).</li>
                    <li>Parcerias ou acordos contratuais que exijam emissão por outro canal (ex: terceirizadas).</li>
                </ul>
                <p class="mt-5 text-center"><strong>Atenção:</strong> Esta ação não poderá ser desfeita.</p>
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button (click)="cancelDialogInvoiceBlocked()" [outlined]="true" label="Cancelar"
            severity="secondary"></p-button>
        <p-button (click)="dialogInvoiceBlocked = false" label="Bloquear Emissão"></p-button>
    </ng-template>
</p-confirmDialog>
